import axios from "axios";

export default async function printPrescriptionReports(name, ...params) {
  const token = localStorage.getItem("token");

  const reports = {
    reportCfta: () => reportCfta(token, ...params),
    reportCrea: () => reportCrea(token, ...params),
    report: () => report(token, ...params),
    reportProduct: () => reportProduct(token, ...params),
    estorno: () => reportEstorno(token, ...params),
    reportClient: () => reportClient(token, ...params),
  }

  if (!reports[name]) {
    console.log('invalid name')
    return
  }

  return await reports[name]()
}

async function report(token, startDate, endDate, columnsJson, finishing) {
  const url = `${process.env.VUE_APP_URL_BACKEND}/sales/relatorio/receitas?auth=${token}&startDate=${startDate}&endDate=${endDate}&columns=${columnsJson}&finishing=${finishing}`

  return await generateReport(url);
}

async function reportProduct(token, startDate, endDate) {
  const url = `${process.env.VUE_APP_URL_BACKEND}/sales/produtos/receitas?auth=${token}&startDate=${startDate}&endDate=${endDate}`

  return await generateReport(url);
}

async function reportEstorno(token, startDate, endDate) {
  const url = `${process.env.VUE_APP_URL_BACKEND}/sales/estornos/gerais?auth=${token}&startDate=${startDate}&endDate=${endDate}`

  return await generateReport(url);
}

async function reportClient(token, idCliente, startDate, endDate, columnsJson) {
  const url = `${process.env.VUE_APP_URL_BACKEND}/sales/receitas/cliente?auth=${token}&idCliente=${idCliente}&startDate=${startDate}&endDate=${endDate}&columns=${columnsJson}`

  return await generateReport(url);
}

async function reportCfta(token, startDate, endDate, artTrt, addLeadingZero) {
  const url = `${process.env.VUE_APP_URL_BACKEND}/sales/generate/reports/cfta?auth=${token}&startDate=${startDate}&endDate=${endDate}&artTrt=${artTrt}&addLeadingZero=${addLeadingZero}`

  return await generateReport(url);
}

async function reportCrea(token, startDate, endDate, artTrt) {
  const url = `${process.env.VUE_APP_URL_BACKEND}/sales/generate/reports/crea?auth=${token}&startDate=${startDate}&endDate=${endDate}&artTrt=${artTrt}`

  return await generateReportCrea(url);
}

async function generateReport(url) {
  try {
    const response = await axios.get(url);

    if (response.status !== 200) {
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Erro ao gerar o relatório:", error);
    return null;
  }
}

async function generateReportCrea(url) {
  try {
    const response = await axios.get(url, {
      responseType: "blob",
    });
    const href = URL.createObjectURL(response.data);

    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', 'relatorio_crea.txt');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  } catch (error) {
    console.error("Erro ao gerar o relatório:", error);
    return null;
  }
}